import { Controller } from "@hotwired/stimulus"

// Toggles a custom prompt textarea for the auto-fix button.
// When the user types instructions, they get injected into the
// existing button_to form as a hidden field before submission.
export default class extends Controller {
  static targets = ["form", "panel", "textarea", "icon"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("rotate-180")
  }

  submit() {
    const form = this.formTarget
    const text = this.textareaTarget.value.trim()

    if (text) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "custom_prompt"
      input.value = text
      form.appendChild(input)
    }

    form.requestSubmit()
  }
}
